import React, { useEffect, useState } from "react";
import { Col, Divider, Form, Input, notification, Row, Spin } from "antd";
import WebUtils from "../../utils/WebUtils";
import { passChangeApi } from "../../api/candidate";
import Loader from "../Loader";

function PasswordChange() {
  const [edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [changedPass, setChangedPass] = useState();
  const [changedPassConfirm, setChangedPassConfirm] = useState();
  const [changedPassNew, setChangedPassNew] = useState();
  const [form] = Form.useForm();

  const handleCancel = (e) => {
    e.preventDefault();
    setEdit(false);
    form.resetFields(); // Clear all fields and validation messages
  };

  const handleSubmit = (value) => {
    const currPass = btoa(value.currPass);
    const newPass = btoa(value.newPass);
    // console.log(currPass, newPass);
    const url = `${passChangeApi}?currentPassword=${currPass}&newPassword=${newPass}`;

    setLoading(true);

    WebUtils.httpOperations(url, {}, "POST")
      .then((result) => {
        // console.log(result);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          //   console.log(result);
          notification.success({
            message: "Password changed successfully",
            placement: "topRight",
            showProgress: true,
          });
          form.resetFields();
          setLoading(false);
          setEdit(false);
        } else {
          setLoading(false);
          notification.warning({
            message: "Password change failed",
            // icon: <Icon type="green-tick" />,
            placement: "topRight",
            showProgress: true,
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
    // console.log(value);
  };
  const passwordRules = [
    {
      required: true,
      message: "Please enter the new password!",
    },

    {
      pattern:
        /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$.()-{}|\;:'"_+,<>=~`#!%*?&]{8,}$/,
      message:
        "Password must be at least 8 characters long and contain at least one capital letter, one number, and one special character!",
    },
    ({ getFieldValue }) => ({
      validator(_, value) {
        if (!value || getFieldValue("currPass") !== value) {
          return Promise.resolve();
        }
        return Promise.reject(
          new Error(
            "The new password must be different from the current password!"
          )
        );
      },
    }),
  ];

  useEffect(() => {
    // console.log(form);
    if (changedPass?.length > 0 && changedPassConfirm?.length > 0) {
      form.setFieldsValue({
        confirmPass: form.getFieldValue("confirmPass"),
      });
      form.validateFields(["confirmPass"]);
    }
  }, [changedPass]);
  useEffect(() => {
    // console.log(form);
    if (changedPass?.length > 0 && changedPassNew?.length > 0) {
      form.setFieldsValue({
        newPass: form.getFieldValue("newPass"),
      });
      form.validateFields(["newPass"]);
    }
  }, [changedPassNew]);

  return (
    <>
      {loading && <Loader />}
      <div>
        <div className="w-[100%] lg:w-[78%] xl:w-[82%]">
          <div>
            <p className="text-[#101828] font-semibold text-[1.4rem]">
              Password
            </p>
            <p className="text-[#475467] w-[100%] text-[0.95rem]">
              Please enter your current password to change your password.
            </p>
          </div>
          <Divider />
          <Form form={form} onFinish={handleSubmit}>
            <Row className="mt-6 gap-y-2">
              <Col className="w-full lg:w-[33%]">
                <div className="text-[#475467] font-semibold text-[0.95rem]">
                  Current password
                </div>
              </Col>
              <Col className="space-y-3 w-full lg:w-[50%]">
                <Form.Item
                  name="currPass"
                  className=" p-0 m-0"
                  rules={[
                    {
                      required: true,
                      message: "Please enter the current password!",
                    },
                  ]}
                >
                  <Input.Password
                    className="w-full"
                    placeholder=""
                    disabled={!edit}
                    onChange={(e) => setChangedPassNew(e.target.value)}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row className="mt-4 gap-y-2">
              <Col className="w-full lg:w-[33%]">
                <div className="text-[#475467] font-semibold text-[0.95rem]">
                  New password
                </div>
                <div className="text-[#475467] text-[0.8rem] w-[80%]">
                  Your new password must be more than 8 characters with special
                  characters and numbers.
                </div>
              </Col>
              <Col className="space-y-3 w-full lg:w-[50%]">
                <Form.Item
                  name="newPass"
                  className=" p-0 m-0"
                  rules={passwordRules}
                >
                  <Input.Password
                    className="w-full"
                    disabled={!edit}
                    onChange={(e) => setChangedPass(e.target.value)}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row className="mt-6 gap-y-2">
              <Col className="w-full lg:w-[33%]">
                <div className="text-[#475467] font-semibold text-[0.95rem]">
                  Confirm new password
                </div>
              </Col>
              <Col className="space-y-3 w-full lg:w-[50%]">
                <Form.Item
                  name="confirmPass"
                  className=" p-0 m-0"
                  rules={[
                    {
                      required: true,
                      message: "Please enter the confirm password!",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("newPass") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error("Passwords do not match!")
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password
                    className="w-full"
                    placeholder=""
                    disabled={!edit}
                    onChange={(e) => setChangedPassConfirm(e.target.value)}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row className="mt-5 gap-y-2">
              <Col className="w-full flex flex-col-reverse md:flex-row justify-end gap-2">
                {!edit ? (
                  <button
                    type="primary"
                    className="text-[0.85rem] w-full md:w-[110px] btn-orange py-[7px] px-3 text-white rounded-lg shadow-sm"
                    onClick={(e) => {
                      setEdit(true);
                      e.preventDefault();
                    }}
                  >
                    Edit
                  </button>
                ) : (
                  <>
                    <button
                      type="primary"
                      className="text-[0.85rem] w-full md:w-[110px] btn-orange py-[7px] px-3 text-white rounded-lg shadow-sm"
                      htmlType="submit"
                    >
                      Update
                    </button>
                    <button
                      type="default"
                      className="text-[0.85rem] w-full md:w-[110px] bg-white border border-[#D0D5DD] py-[7px] px-3 text-[#344054] rounded-lg shadow-sm"
                      onClick={handleCancel}
                    >
                      Cancel
                    </button>
                  </>
                )}
              </Col>
            </Row>
            <Divider />
          </Form>
        </div>
      </div>
    </>
  );
}

export default PasswordChange;
